module.exports = __webpack_public_path__ + "static/media/LDB-Construction-White.cd74306a.svg";